import numeral from 'numeral';

// ----------------------------------------------------------------------
export function fRSDCurrencyFormat(number: string | number) {
  //set thousands separator to
  const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedNumber} RSD`;
}

export function fCurrency(number: string | number, currency: string = 'RSD') {
  const formattedNumber = numeral(number).format(Number.isInteger(number) ? '0,0' : '0,0.00');
  return `${formattedNumber} ${currency}`;
}

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: string | number) {
  return numeral(number).format();
}

export function fShortenNumber(number: string | number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number: string | number) {
  return numeral(number).format('0.0 b');
}

export const toBase64StringFormat = (imagePath: string): string =>
  imagePath.replace('data:', '').replace(/^.+,/, '');

export const combinePaths = (
  endpoint: string | undefined,
  relativePath: string | undefined
): string | undefined => {
  if (!endpoint || !relativePath) return undefined;
  return `${endpoint}${relativePath}`;
};

export const getNewUuid = (): string => {
  const uuid = require('uuid');
  return uuid.v4();
};

export const getNameInitials = (fullName: string): string => {
  return fullName
    .split(' ')
    .map((n) => n[0])
    .join('.');
};
